import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "interactive-viewer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "iframe-container" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://interactive-viewer-5204c4f72d1d.herokuapp.com/",
    frameborder: "0"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomText = _resolveComponent("CustomText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CustomText, { tag: "h1" }, {
      default: _withCtx(() => [
        _createTextVNode(" Interactive Viewer ")
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_CustomText, {
      tag: "h2",
      class: "custom-text-h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" This project is one of my first three.js projects. I utilized blender to design the 3D model and added ThreeJS's built in orbit controls to allow for control/interactivity. ")
      ]),
      _: 1
    })
  ]))
}